import React, { useMemo } from 'react';
import { useGoBack } from '../../../../../utils/appNavigationNames';
import useOrganizationInvitations from '../../../../../hooks/api/useOrganizationUserInvitations';
import { APITypes } from '../../../../../primary-record-types';
import { useIsDisabledByParent } from '../../../../v2BaseComponents/IsDisabledProvider';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { Form } from '../../../../v2BaseComponents/Form';
import OrganizationInvitationFields from '../../../../shared/OrganizationInvitations/OrganizationInvitationFields';

export type AddOrganizationInvitationScreenOwnProps = {};

export type AddOrganizationInvitationScreenProps = AddOrganizationInvitationScreenOwnProps;

const AddOrganizationInvitationScreen: React.FC<AddOrganizationInvitationScreenProps> = () => {
    const initialValues: APITypes.organizationService.CreateOrganizationUserInvitationRequest = useMemo(
        () => ({
            inviteeEmail: '',
            inviteeFirstName: '',
            inviteeLastName: '',
            inviteeRole: 'agent',
            message: '',
        }),
        [],
    );
    const goBack = useGoBack();
    const { isCreatingInvitation, createInvitation } = useOrganizationInvitations({
        onCreateInvitation: goBack,
    });
    const isDisabledByParent = useIsDisabledByParent(isCreatingInvitation);
    return (
        <AnimateLoadedContent isLoading={isCreatingInvitation}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={initialValues}
                    onSubmit={(values) => createInvitation(values)}
                    isDisabled={isDisabledByParent}
                    onCancel={goBack}
                >
                    {({ isSubmitting }) => (
                        <OrganizationInvitationFields isDisabled={isDisabledByParent || isSubmitting} />
                    )}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddOrganizationInvitationScreen);
